<h1 class="text-2xl md:text-3xl">Connecting Hospitable.com with Airbnb</h1>

<p>We’re an official Airbnb software partner, so connecting takes minutes.</p>

<p>Connecting your Airbnb account will allow you to save time replying to guests and automate the review process.</p>

<p>
  Before you click Continue, make sure you are logged in to Airbnb with the account you want to connect to
  Hospitable.com.
</p>

<form [formGroup]="form">
  <div style="margin-top: 12px; margin-bottom: 12px; margin-left: -6px">
    <mat-checkbox formControlName="agreed_to_tos">
      <span class="text__small">
        I agree to to Hospitable's
        <a href="{{ config.TOS_URL }}" target="_blank" class="strong" target="_blank">Terms of Service</a>
        and
        <a href="{{ config.PRIVACY_POLICY_URL }}" target="_blank" class="strong" target="_blank">Privacy Policy</a>
      </span>
    </mat-checkbox>
  </div>
</form>

<div class="grid grid-flow-col items-center justify-end gap-4 mt-6">
  <sbnb-button [routerLink]="['../']" type="secondary">Cancel</sbnb-button>

  <sbnb-button
    (click)="signUpWithAirbnb()"
    [disabled]="form.invalid"
    [loading]="loading"
    [icon]="form.invalid ? 'airbnb-rose' : 'airbnb-white'"
    [preserveIconColor]="true">
    <span>Continue</span>
  </sbnb-button>
</div>
